import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../../shared/components/AppButton";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { PlusIcon } from "../../../../../../shared/icons/PlusIcon";
import { ChatValidationSwitcher } from "./ChatValidationSwitcher";
import { NormalizedStorageObject } from "../../../../../../services/api/instances/storageApi/types/object_types";
import { ChatbotValue } from "../../../../../../services/api/instances/botApi/types";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import styles from "./styles.module.css";

interface Props {
  bot: NormalizedStorageObject<ChatbotValue>;
  autocomplete: React.ReactNode;
  chatType: "white_list" | "black_list";
  handleAddNewChat: () => void;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
  isDisabled: boolean;
}

export const AddChatAutocompleteBlock = (props: Props) => {
  const { t } = useTranslation();

  const title =
    props.chatType === "white_list"
      ? t("chatbot.additional_title")
      : t("chatbot.blacklist_title");

  return (
    <div className={styles["block-container"]}>
      <AppUnderlinedTitle className={styles.title} leftContent={title}>
        <AppButton
          buttonType="text"
          onClick={props.handleAddNewChat}
          icon={<PlusIcon />}
          disabled={props.isDisabled}
        >
          {t("common.add_button")}
        </AppButton>
      </AppUnderlinedTitle>
      {props.chatType === "black_list" && (
        <ChatValidationSwitcher
          bot={props.bot}
          saveChatbotValue={props.saveChatbotValue}
        />
      )}
      {props.autocomplete}
    </div>
  );
};
